import { Component, OnInit, ViewChild, Input, Output, EventEmitter, AfterViewInit, OnChanges, SimpleChange, ChangeDetectorRef } from '@angular/core';

import { ModalDirective } from 'ng2-bootstrap/modal';

import { FileUploader, FileItem } from 'ng2-file-upload';

import {ImageCropperComponent, CropperSettings} from 'ng2-img-cropper';

import { EmpresasService } from '../_services/empresas.service';

declare var jQuery: any;

const URL = 'http://dev.api.danubio.normapro.es/testfile.php';

@Component({
  selector: 'subidaimagenes',
  templateUrl: './subidaimagenes.template.html'
})
export class SubidaDeImagenes implements OnInit, AfterViewInit, OnChanges {

  @ViewChild('staticModalSubidaImagenes') public staticModalSubidaImagenes:ModalDirective;
  @ViewChild('cropper', undefined)
  cropper:ImageCropperComponent;

  @Input() _mostrarmodal: any;
  @Input() _id_empresa: number;
  @Output() onChangeModal = new EventEmitter<any>();

  mostrarmodal: boolean = true;
  id_empresa: number = 0;

  //public uploader:FileUploader = new FileUploader({url: URL});

  data: any;
  cropperSettings: CropperSettings;

  constructor(
    private empresasService: EmpresasService,
    private ref: ChangeDetectorRef ) {

          this.cropperSettings = new CropperSettings();
          this.cropperSettings.width = 600;
          this.cropperSettings.height = 600;
          this.cropperSettings.croppedWidth =600;
          this.cropperSettings.croppedHeight = 600;
          this.cropperSettings.canvasWidth = 400;
          this.cropperSettings.canvasHeight = 300;
          this.cropperSettings.noFileInput = true;
          this.cropperSettings.compressRatio = 1;

          this.data = {};

    /*this.uploader.onProgressItem = (fileItem: FileItem, progress: any) => {
        this.ref.detectChanges();
    }

    this.uploader.onCompleteItem = (item:any, response:any, status:any, headers:any) => {
            console.log("ImageUpload:uploaded:", item, response);
        };*/

  }

  fileChangeListener($event) {
      var image:any = new Image();
      var file:File = $event.target.files[0];
      var myReader:FileReader = new FileReader();
      var that = this;
      myReader.onloadend = function (loadEvent:any) {
          image.src = loadEvent.target.result;
          that.cropper.setImage(image);

      };

      myReader.readAsDataURL(file);
  }

  ngOnChanges(changes: {[ propName: string]: SimpleChange}){

    if (changes['_mostrarmodal']){
      this.mostrarmodal = changes['_mostrarmodal'].currentValue;
    }

    if (changes['_id_empresa']){
      this.id_empresa = changes['_id_empresa'].currentValue;
    }

  }

  ngOnInit() {
  }

  ngAfterViewInit(){
    this.abrirModal();
  }

  abrirModal(){
    if (this.mostrarmodal){
      this.staticModalSubidaImagenes.show();
    }
  }

  cerrarModal(guardar: boolean = false){

    this.staticModalSubidaImagenes.hide();
    this.onChangeModal.emit(true);

  }

  subirLogo(){

    let empresa: any;

    empresa = {
      img : this.data.image,
      id_empresa: this.id_empresa
    };


    this.empresasService.setLogoCropped(empresa).subscribe(
      data => {
        if (data){

          this.cerrarModal(true);

        }
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/subidaimagenes/subidaimagenes.component.ts